__turbopack_context__.v({
  "title": "MenuContainer-module-scss-module__x2TUpa__title",
});
